/*eslint-disable*/
import React from "react";
import { Flex, Link, List, ListItem, Text } from "@chakra-ui/react";

export default function Footer() {
  return (
    <Flex
      flexDirection={{
        base: "column",
        xl: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent="space-between"
      px="20px"
      pb="20px"
    >
      <Text
        color="gray.400"
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", xl: "0px" }}
      >
        &copy; {1900 + new Date().getYear()}{" "}
        <Link href="https://dealeralchemist.com/" target="_blank" fontSize="sm">
          Kirin Consulting, LLC DBA Dealer Alchemist.
        </Link>{" "}
        -{" "}
        <Text as="span" fontSize="sm">
          Made with ❤️. All rights reserved. All other trademarks and logos are
          the property of their respective owners.
        </Text>
      </Text>
    </Flex>
  );
}
